(ns app.front.view.inspections.util
  (:require [app.i18n.model :as i18n-model]
            [clojure.string :as str]))

(defn qualification->string [tr qualification-kind]
  (tr [(if (nil? qualification-kind)
         :inspection/no-qualification-required
         qualification-kind)]))

(defn qualifications->string [tr qualifications]
  (if (seq qualifications)
    (->> qualifications
         (map (partial qualification->string tr))
         (str/join ", "))
    (tr [:inspection/no-qualification-required])))

(defn template->string
  "Give a human-readable name to inspection-template"
  [tr template]
  (->> template
       :inspection.template/qualification
       (qualifications->string tr)))

(defn template-kind->name
  [template-kind language]
  (-> template-kind
      :inspection.template.kind/names
      (i18n-model/get-text-from-entities-or-map language)
      (or (:inspection.template.kind/name template-kind))))

;;; inspection state icons
(def pill-text :span.py-1.my-1.font-bold.text-xs.tracking-wider.uppercase.rounded-full)
(def green {:class "px-3 text-green-800 bg-green-200"})
(def red {:class "px-3 text-red-800 bg-red-200"})
(def black {:class "px-3 text-white bg-gray-900"})
(def transparent {:class "px-0 text-gray-700 mx-1"})
